'use client';

import { useTheme } from 'next-themes';
import { Sun, Monitor, Moon, Check } from 'lucide-react';
import { useEffect, useState } from 'react';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger
} from '@/_components/UIComponents/DropdownMenu';
import { Button } from '@/_components/UIComponents/Button';

const THEME_OPTIONS = [
	{ value: 'light', icon: Sun, label: 'Light' },
	{ value: 'system', icon: Monitor, label: 'System' },
	{ value: 'dark', icon: Moon, label: 'Dark' }
] as const;

export default function ThemeToggle() {
	const { theme, setTheme } = useTheme();
	const [mounted, setMounted] = useState(false);

	useEffect(() => setMounted(true), []);

	// Avoid hydration mismatch — render placeholder with same dimensions
	if (!mounted) {
		return <div className='bg-secondary h-8 w-8 rounded-md' />;
	}

	const currentOption = THEME_OPTIONS.find((o) => o.value === theme) ?? THEME_OPTIONS[2];
	const CurrentIcon = currentOption.icon;

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					variant='ghost'
					size='sm'
					className='h-8 w-8 px-0'
					aria-label='Toggle theme'
				>
					<CurrentIcon className='h-4 w-4' />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align='end'>
				{THEME_OPTIONS.map(({ value, icon: Icon, label }) => (
					<DropdownMenuItem
						key={value}
						onClick={() => setTheme(value)}
						className='cursor-pointer'
					>
						<Icon className='mr-2 h-4 w-4' />
						{label}
						{theme === value && <Check className='ml-auto h-4 w-4' />}
					</DropdownMenuItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
